module.exports = __webpack_public_path__ + "img/Antigua and Barbuda.7fde9e1b.svg";